import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { getCatalogue } from "../REDUX/actions/catalogue";
import Cart from "../Components/NewComponents/Cart";
import Step1Catalogue from "../Components/NewComponents/CatalogueSteps/Step1Catalogue";
import Step2Catalogue from "../Components/NewComponents/CatalogueSteps/Step2Catalogue";
import Step3Catalogue from "../Components/NewComponents/CatalogueSteps/Step3Catalogue";
import Step4Catalogue from "../Components/NewComponents/CatalogueSteps/Step4Catalogue";
import CartSelector from "../Components/NewComponents/CartSelector";
import { useTranslation } from "react-i18next";
import { useCanOrder } from "../hooks/useCanSeePrices";

const tabsMap = {
  Products: "Produits",
  Accessories: "Accessoires",
  "Marketing Products": "Produits marketing",
  "Spare Part": "Pièce Détachée",
  Services: "Services",
  "Other branded products": "Produits d'autres marques",
  SPA: "SPA",
  "SWIM SPA": "SPA DE NAGE",
  SAUNA: "SAUNA",
};

const CatalogueNewView = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState();
  const [activeTab, setActiveTab] = useState("Products");
  const [productsactiveTab, setproductsActiveTab] = useState(t("SPA"));
  const [step, setStep] = useState(1);
  const canOrder = useCanOrder();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    location?.search?.includes("Erreur=") && navigate("/catalogue");
  }, [location]);

  useEffect(() => {
    const controller = new AbortController();

    dispatch(
      getCatalogue(
        tabsMap[activeTab],
        tabsMap[productsactiveTab],
        searchInput,
        controller.signal,
      ),
    );

    return () => controller.abort();
  }, [activeTab, searchInput, productsactiveTab, dispatch, t]);

  return (
    <div className="position-relative h-100">
      {/* A commercial browses (stock, public prices): no cart beside it. */}
      <div style={{ width: canOrder ? "65vw" : "100%" }} className="h-100">
        {canOrder && (
          <CartSelector
            searchInput={searchInput}
            activeTab={activeTab}
            productsactiveTab={productsactiveTab}
          />
        )}
        {step === 1 && (
          <Step1Catalogue
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            productsactiveTab={productsactiveTab}
            setproductsActiveTab={setproductsActiveTab}
          />
        )}
        {step === 2 && (
          <Step2Catalogue
            searchInput={searchInput}
            activeTab={activeTab}
            productsactiveTab={productsactiveTab}
          />
        )}
        {step === 3 && (
          <Step3Catalogue
            searchInput={searchInput}
            activeTab={activeTab}
            productsactiveTab={productsactiveTab}
          />
        )}
        {step === 4 && (
          <Step4Catalogue
            searchInput={searchInput}
            activeTab={activeTab}
            productsactiveTab={productsactiveTab}
          />
        )}
      </div>
      <Cart
        step={step}
        setStep={setStep}
        activeTab={activeTab}
        searchInput={searchInput}
        productsactiveTab={productsactiveTab}
      />
    </div>
  );
};

export default CatalogueNewView;
